import { BrowserCacheLocation } from '@azure/msal-browser'

const AAD_CLIENT_ID = process.env.REACT_APP_AAD_CLIENT_ID || '<React App Client ID>'
const AAD_TENANT_ID = process.env.REACT_APP_AAD_TENANT_ID || '<Tenant ID>'

// Dynamically determine redirect URI based on current environment
const getCurrentRedirectUri = () => {
	if (typeof window !== 'undefined' && window.location && window.location.origin.includes('localhost')) {
		return `${window.location.origin}/auth/callback`;
	}
	return process.env.REACT_APP_AAD_REDIRECT_URI || '<REACT_APP_AAD_REDIRECT_URI>';
};

const AAD_REDIRECT_URI = getCurrentRedirectUri();

const AAD_LOGIN_AUTHORITY = `https://login.microsoftonline.com/${AAD_TENANT_ID}`

// Default to the provided API scope; allow override via env
const AAD_API_SCOPE =
	process.env.REACT_APP_AAD_API_SCOPE ||
	'<REACT_APP_AAD_API_SCOPE>'
//'api://localhost/access_as_user'

export const msalConfig = {
	auth: {
		clientId: AAD_CLIENT_ID,
		authority: AAD_LOGIN_AUTHORITY,
		redirectUri: AAD_REDIRECT_URI,
	},
	cache: {
		cacheLocation: BrowserCacheLocation.SessionStorage,
		storeAuthStateInCookie: false,
	},
}

export const loginRequest = {
	scopes: ['openid', 'profile', AAD_API_SCOPE],
}


